import { gql, useQuery } from "@apollo/client"
import { offsetLimitPagination } from "@apollo/client/utilities"
import { WORKFLOW_SUMMARY_FRAGMENT } from "./fragments/workflowSummaryFragment"

const GET_MY_CURRENTLY_ASSIGNED_WORKFLOWS_QUERY = gql`
  query MyCurrentlyAssignedWorkflows($filter: CurrentlyAssignedWorkflowsInput, $limit: Int) {
    currentlyAssignedWorkflows {
      list(filter: $filter, limit: $limit) {
        ...WorkflowFields
      }
      count(filter: $filter)
    }
  }
  ${WORKFLOW_SUMMARY_FRAGMENT}
`

const MY_CURRENTLY_ASSIGNED_WORKFLOWS_COUNT_QUERY = gql`
  query MyCurrentlyAssignedWorkflowsCount($filter: CurrentlyAssignedWorkflowsInput) {
    currentlyAssignedWorkflows {
      count(filter: $filter)
    }
  }
`

const myCurrentlyAssignedWorkflowsTypePolicies = {
  scoped: {
    CurrentlyAssignedWorkflowsQuery: {
      fields: {
        list: offsetLimitPagination(["filter"]),
        count: {
          keyArgs: ["filter"]
        }
      }
    }
  }
}

/**
 * @description A hook for fetching my workflows.
 * @param {object} options - Options to pass to the useQuery hook.
 */
const useQueryCurrentlyAssignedWorkflows = (options) => useQuery(GET_MY_CURRENTLY_ASSIGNED_WORKFLOWS_QUERY, options)

const useQueryCurrentlyAssignedWorkflowsCount = (options) =>
  useQuery(MY_CURRENTLY_ASSIGNED_WORKFLOWS_COUNT_QUERY, options)

export {
  useQueryCurrentlyAssignedWorkflows,
  useQueryCurrentlyAssignedWorkflowsCount,
  GET_MY_CURRENTLY_ASSIGNED_WORKFLOWS_QUERY,
  MY_CURRENTLY_ASSIGNED_WORKFLOWS_COUNT_QUERY,
  myCurrentlyAssignedWorkflowsTypePolicies
}
